import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { Language, Languages } from '../../core/languages';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LanguageResolver implements Resolve<Language> {

  constructor(private translateService: TranslateService) {}

  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Language> {
    const locale: string = route.queryParams.lang || localStorage.getItem('locale');
    const language = Languages.resolveFromLocaleOrFallbackOnDefault(locale);
    return this.translateService.use(language.ngxTranslateLocale).pipe(
      map(_ => language)
    );
  }
}
